import { render, staticRenderFns } from "./historyItem.vue?vue&type=template&id=682d86ea&scoped=true"
import script from "./historyItem.vue?vue&type=script&lang=js"
export * from "./historyItem.vue?vue&type=script&lang=js"
import style0 from "./historyItem.vue?vue&type=style&index=0&id=682d86ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d86ea",
  null
  
)

export default component.exports